import * as Navigation from "./navigation";
export { Navigation };



//////////////////
// WEBPACK FOOTER
// ./app/shared/patterns/global/header/navigation/index.ts
// module id = uqb7
// module chunks = 2